import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils';

@Component({
  selector: 'alert-dialog-actions',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class AlertDialogActions {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'flex items-center justify-end gap-x-3',
      'mt-3',

      // User classes
      this.userClass(),
    ),
  );
}
